import { PageContent } from 'components/layout/PageContent'
import { useIframesAtendimentoQuery } from 'graphql/hooks.generated'
import { TipoAtendimentoProfissional, TipoSistemaExternoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useLinkSistemaExterno } from 'view/sistemas-externos/components/useLinkSistemaExterno'

import { AtendimentoFooter } from '../AtendimentoFooter'
import { SistemasExternosAtendimentoDetail } from './SistemasExternosAtendimentoDetail'
import { SistemasExternosAtendimentoList } from './SistemasExternosAtendimentoList'

interface SistemasExternosAtendimentoViewProps {
  atendimentoId?: ID
  cidadaoId: ID
  tipoAtendimentoProfissional?: TipoAtendimentoProfissional
  isRegistroTardio?: boolean
  clearCache?(updateState?: boolean): void
  isAtendimentoObservacao?: boolean
  isObservacaoAndResponsavel?: boolean
  hasFooter?: boolean
}

export interface AtendimentoIframe {
  id: string
  providerId: string
  nome: string
}

export function SistemasExternosAtendimentoView(props: Readonly<SistemasExternosAtendimentoViewProps>) {
  const {
    atendimentoId,
    cidadaoId,
    tipoAtendimentoProfissional,
    isRegistroTardio = false,
    clearCache,
    isAtendimentoObservacao = false,
    isObservacaoAndResponsavel = false,
    hasFooter = true,
  } = props

  const { data } = useIframesAtendimentoQuery({
    variables: {
      input: {
        cidadaoId,
        tipoAtendimentoProfissional,
        tipoSistemaExterno: TipoSistemaExternoEnum.ATENDIMENTO,
      },
    },
  })

  const iframesAtendimento = useMemo(() => data?.iframes ?? [], [data?.iframes])

  const { iframeId } = useParams<{ iframeId: string }>()

  const iframeSelecionado = useMemo<AtendimentoIframe | null>(() => {
    if (!iframeId || !iframesAtendimento) return null
    return iframesAtendimento.find((iframe) => iframe?.id === iframeId) ?? null
  }, [iframeId, iframesAtendimento])

  const { url, refresh, loading } = useLinkSistemaExterno(iframeSelecionado, cidadaoId)
  return (
    <>
      <PageContent fluid type='filled'>
        {iframeSelecionado ? (
          <SistemasExternosAtendimentoDetail
            atendimentoIframe={iframeSelecionado}
            url={url}
            onRefresh={refresh}
            loading={loading}
          />
        ) : (
          <SistemasExternosAtendimentoList items={iframesAtendimento} />
        )}
      </PageContent>

      {hasFooter && (
        <AtendimentoFooter
          atendimentoId={atendimentoId}
          tipoAtendimentoProfissional={tipoAtendimentoProfissional}
          clearCache={clearCache}
          isRegistroTardio={isRegistroTardio}
          isAtendimentoObservacao={isAtendimentoObservacao}
          isObservacaoAndResponsavel={isObservacaoAndResponsavel}
        />
      )}
    </>
  )
}
